import { application } from "./application";

// Shared controllers
import DropdownController from "../../shared/controllers/dropdown_controller";
application.register("dropdown", DropdownController);

// Local controllers (auto-imported by esbuild plugin)
// Note: Third-party controllers (checkbox-select-all, textarea-autogrow, sortable)
// are wrapped by local controller files that extend them with custom behavior
export * from "stimulus:controllers";
